// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3b481b0f","453":"971aea23"}[chunkId] + ".chunk.js";
};